import React from 'react';
import PropTypes from 'prop-types';
import withScrollToTop from '../utility/withScrollToTop';

const Wrapper = ({ children }) => (
  <div
    className="dls-gray-01-bg flex flex-align-center flex-justify-center flex-column margin-4-t height-full"
    style={{
      background: "url('https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/brand/worldservice-tile-gray.svg')",
      backgroundSize: 'contain',
    }}
  >
    {children}
  </div>
);

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withScrollToTop(Wrapper);
